import { defineStore } from "pinia";

export const useVisiMisiStore = defineStore("visiMisi", {
  state: () => ({
    data: [],
    loading: false,
  }),
  actions: {
    async fetchDummyData() {
      this.loading = true;
      try {
        this.data = [
          {
            id: 1,
            title: "VISI MISI STIKes SUMBER WARAS",
            prodi: "STIKes SUMBER WARAS",
            visi: `
              <p><strong>Visi:</strong> Menjadi Sekolah Tinggi Ilmu Kesehatan yang terkemuka di Indonesia,
              menghasilkan tenaga kesehatan profesional, unggul, dan kompetitif di tingkat nasional dan internasional pada tahun 2046.</p>
            `,
            misi: `
              <ul>
                <li>Menyelenggarakan pendidikan kesehatan yang sesuai standar pendidikan tinggi.</li>
                <li>Mengembangkan penelitian bidang kesehatan yang inovatif.</li>
                <li>Melaksanakan pengabdian kepada masyarakat berdasarkan hasil penelitian.</li>
                <li>Menjalin kerjasama dengan lembaga pendidikan dan layanan kesehatan secara nasional dan internasional.</li>
                <li>Menyelenggarakan pendidikan kesehatan yang sesuai standar pendidikan tinggi.</li>
                <li>Mengembangkan penelitian bidang kesehatan yang inovatif.</li>
                <li>Melaksanakan pengabdian kepada masyarakat berdasarkan hasil penelitian.</li>
                <li>Menjalin kerjasama dengan lembaga pendidikan dan layanan kesehatan secara nasional dan internasional.</li>
                <li>Menyelenggarakan pendidikan kesehatan yang sesuai standar pendidikan tinggi.</li>
                <li>Mengembangkan penelitian bidang kesehatan yang inovatif.</li>
                <li>Melaksanakan pengabdian kepada masyarakat berdasarkan hasil penelitian.</li>
                <li>Menjalin kerjasama dengan lembaga pendidikan dan layanan kesehatan secara nasional dan internasional.</li>
                <li>Menyelenggarakan pendidikan kesehatan yang sesuai standar pendidikan tinggi.</li>
                <li>Mengembangkan penelitian bidang kesehatan yang inovatif.</li>
                <li>Melaksanakan pengabdian kepada masyarakat berdasarkan hasil penelitian.</li>
                <li>Menjalin kerjasama dengan lembaga pendidikan dan layanan kesehatan secara nasional dan internasional.</li>
                <li>Menyelenggarakan pendidikan kesehatan yang sesuai standar pendidikan tinggi.</li>
                <li>Mengembangkan penelitian bidang kesehatan yang inovatif.</li>
                <li>Melaksanakan pengabdian kepada masyarakat berdasarkan hasil penelitian.</li>
                <li>Menjalin kerjasama dengan lembaga pendidikan dan layanan kesehatan secara nasional dan internasional.</li>
                <li>Menyelenggarakan pendidikan kesehatan yang sesuai standar pendidikan tinggi.</li>
                <li>Mengembangkan penelitian bidang kesehatan yang inovatif.</li>
                <li>Melaksanakan pengabdian kepada masyarakat berdasarkan hasil penelitian.</li>
                <li>Menjalin kerjasama dengan lembaga pendidikan dan layanan kesehatan secara nasional dan internasional.</li>
                <li>Menyelenggarakan pendidikan kesehatan yang sesuai standar pendidikan tinggi.</li>
                <li>Mengembangkan penelitian bidang kesehatan yang inovatif.</li>
                <li>Melaksanakan pengabdian kepada masyarakat berdasarkan hasil penelitian.</li>
                <li>Menjalin kerjasama dengan lembaga pendidikan dan layanan kesehatan secara nasional dan internasional.</li>
                <li>Menyelenggarakan pendidikan kesehatan yang sesuai standar pendidikan tinggi.</li>
                <li>Mengembangkan penelitian bidang kesehatan yang inovatif.</li>
                <li>Melaksanakan pengabdian kepada masyarakat berdasarkan hasil penelitian.</li>
                <li>Menjalin kerjasama dengan lembaga pendidikan dan layanan kesehatan secara nasional dan internasional.</li>
                <li>Menyelenggarakan pendidikan kesehatan yang sesuai standar pendidikan tinggi.</li>
                <li>Mengembangkan penelitian bidang kesehatan yang inovatif.</li>
                <li>Melaksanakan pengabdian kepada masyarakat berdasarkan hasil penelitian.</li>
                <li>Menjalin kerjasama dengan lembaga pendidikan dan layanan kesehatan secara nasional dan internasional.</li>
              </ul>
            `,
            tujuan: `
              <ul>
                <li>Menghasilkan lulusan yang unggul, berakhlak mulia, dan mampu bersaing secara global.</li>
                <li>Menghasilkan penelitian dan pengabdian yang berdampak pada pengembangan ilmu kesehatan dan kesejahteraan masyarakat.</li>
              </ul>
            `,
          },
          {
            id: 2,
            title: "Visi Misi Diploma Tiga Keperawatan",
            prodi: "DIPLOMA TIGA KEPERAWATAN",
            visi: `
              <p><strong>Visi:</strong> Menjadikan Program Studi Diploma Tiga Keperawatan yang berkualitas dan menghasilkan lulusan yang profesional, unggul, dan kompetitif dalam pemenuhan kebutuhan dasar (Henderson) di tingkat nasional maupun internasional pada tahun 2046.</p>
            `,
            misi: `
              <ul>
                <li>Menyelenggarakan pendidikan keperawatan berkualitas berbasis kompetensi.</li>
                <li>Melaksanakan penelitian berkelanjutan untuk pengembangan ilmu keperawatan.</li>
                <li>Melaksanakan pengabdian masyarakat dalam pemenuhan kebutuhan dasar kesehatan.</li>
              </ul>
            `,
            tujuan: `
              <ul>
                <li>Menghasilkan lulusan keperawatan yang unggul dan profesional.</li>
                <li>Menghasilkan produk penelitian yang aplikatif dan bermanfaat untuk masyarakat.</li>
              </ul>
            `,
          },
          {
            id: 3,
            title: "Visi Misi Administrasi Kesehatan",
            prodi: "ADMINISTRASI KESEHATAN",
            visi: `
              <p><strong>Visi:</strong> Menjadi Program Studi Administrasi Kesehatan yang menghasilkan tenaga kesehatan berkompeten, profesional, inovatif, dan unggul dalam bidang Administrasi Rekam Medik di tingkat nasional maupun internasional pada tahun 2046.</p>
            `,
            misi: `
              <ul>
                <li>Menyelenggarakan pendidikan administrasi kesehatan secara profesional dan transparan.</li>
                <li>Melaksanakan riset untuk peningkatan keilmuan bidang administrasi kesehatan.</li>
                <li>Melaksanakan pengabdian kepada masyarakat dalam bidang pengelolaan data dan rekam medis.</li>
              </ul>
            `,
            tujuan: `
              <ul>
                <li>Meningkatkan daya saing lulusan di bidang administrasi kesehatan.</li>
                <li>Mengembangkan kemitraan dan riset berkualitas di tingkat nasional dan internasional.</li>
              </ul>
            `,
          },
          {
            id: 4,
            title: "Visi Misi S1 Keperawatan dan Profesi NERS",
            prodi: "S1 KEPERAWATAN DAN PROFESI NERS",
            visi: `
              <p><strong>Visi:</strong> Menjadikan Program Studi Keperawatan dan Profesi NERS yang berkualitas, menghasilkan lulusan yang profesional, unggul, dan kompetitif di bidang perawatan medikal bedah pada tahun 2046.</p>
            `,
            misi: `
              <ul>
                <li>Menyelenggarakan proses pendidikan berbasis kompetensi dalam perawatan medikal bedah.</li>
                <li>Melaksanakan penelitian untuk pengembangan IPTEK keperawatan medikal bedah.</li>
                <li>Melaksanakan pengabdian masyarakat dalam meningkatkan derajat kesehatan masyarakat.</li>
                <li>Mengembangkan jejaring kerjasama nasional dan internasional untuk mendukung tridarma perguruan tinggi.</li>
              </ul>
            `,
            tujuan: `
              <ul>
                <li>Menghasilkan perawat profesional di bidang medikal bedah yang mampu bersaing secara global.</li>
                <li>Meningkatkan mutu tridarma perguruan tinggi melalui kolaborasi dan inovasi.</li>
              </ul>
            `,
          },
        ];
      } catch (e) {
        console.error("❌ Failed to load data", e);
      } finally {
        this.loading = false;
      }
    },
  },
});
